import { createAction } from "@reduxjs/toolkit";

export const setLettersData = createAction("assets/setLettersData")
export const setElementsData = createAction("assets/setElementsData")